import { useState } from "react";

import styles from "./BookWithConfidence.module.css";
import EnquiryModal from "./EnquiryModal";

interface BookWithConfidenceProps {
  className?: string;
}

function BookWithConfidence(props: BookWithConfidenceProps) {
  const [showModal, setShowModal] = useState(false);
  const { className } = props;

  const openModal = () => {
    setShowModal(true);
  };

  return (
    <>
      <div
        className={`${styles.banner__container} ${className || ""}`}
        role="region"
        aria-label="Enquiry banner"
      >
        <div className={styles.wrapper}>
          <span className={styles.banner__message}>
            Book with confidence... we are the world's largest golf travel
            company!
          </span>
          <button
            className={styles.banner__cta}
            onClick={openModal}
            data-gtm-category="All pages"
            data-gtm-action="General enquiry"
            data-gtm-label="Clicked"
          >
            Enquire now
          </button>
        </div>
      </div>
      <EnquiryModal isOpen={showModal} onClose={() => setShowModal(false)} />
    </>
  );
}

export default BookWithConfidence;
export { BookWithConfidence, type BookWithConfidenceProps };
